import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import GameEvent from "../../../core/application/GameEvent";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
export default class PauseOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this.createButton(this._target.pauseButton, this._onIconClicked.bind(this));
        this.createButton(this._target.resumeButton);

        this.registerEventListener(GameEvent.PAUSE_GAME, this._handlePauseGame.bind(this));
        this.registerEventListener(GameEvent.RESUME_GAME, this._handleResumeGame.bind(this));
    }

    _handlePauseGame() {
        this._target.gotoAndStop(1);
    }

    _handleResumeGame() {
        this._target.gotoAndStop(0);
    }
    _onIconClicked() {
        this.openPopup(SkinKeyRegistry.PAUSE_POPUP_SKIN, null, {
            needsOverlay: false,
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 150)
        });
    }
}